import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { InternalRoutes } from '../../../enum/InternalRoutes';

type BackButtonProps = {
    page?: string;
};

export function BackButton({ page }: BackButtonProps) {
    const { id } = useParams();
    const navigate = useNavigate();
    const onBack = () =>
        page !== 'discovery_search'
            ? window.history.length > 1
                ? navigate(-1)
                : navigate('/', { replace: true })
            : navigate(`${InternalRoutes.BRAND_CAMPAIGN_DISCOVERY}/${id}`);
    return (
        <Button variant="outline-secondary" onClick={onBack} className="mr-lg-3 mr-2">
            <FaArrowLeft />
        </Button>
    );
}
